import { useWindowSize } from 'react-use';

import MOBILE_VIEWPORT from 'constants/ui/mobileViewport.const';

const useIsMobileViewport = () => {
  const { width: windowWidth } = useWindowSize();
  return windowWidth <= MOBILE_VIEWPORT;
};

export default useIsMobileViewport;
